<template>
  <crud-layout :title="title" :subtitle="subtitle">

    <template v-slot:list>
      <cobranza-list
          ref="list"
          @update="update"
          @delete="remove"
          @show="show"

      />
    </template>


    <add-button v-if="$store.getters.hasPermission('COBRANZA_CREATE')" @click="create"></add-button>

    <cobranza-create v-if="creating"
                     :open="creating"
                     v-on:itemCreated="onItemCreated"
                     v-on:close="creating=false"
    />

    <cobranza-update v-if="updating"
                     :open="updating"
                     :item="itemToEdit"
                     v-on:itemUpdated="onItemUpdated"
                     v-on:close="updating=false"
    />

    <cobranza-show v-if="showing"
                   :open="showing"
                   :item="itemToShow"
                   v-on:close="showing=false"
    />

    <cobranza-delete v-if="deleting"
                     :open="deleting"
                     :item="itemToDelete"
                     v-on:itemDeleted="onItemDeleted"
                     v-on:close="deleting=false"
    />

    <snackbar v-model="flash"/>

  </crud-layout>
</template>

<script>

import CobranzaCreate from "../CobranzaCreate";
import CobranzaUpdate from "../CobranzaUpdate";
import CobranzaDelete from "../CobranzaDelete";
import CobranzaShow from "../CobranzaShow";
import CobranzaList from "../CobranzaListCustom";

import {CrudLayout, AddButton, Snackbar} from "@dracul/common-frontend"

export default {
  name: "CobranzaCrud",
  components: {
    CrudLayout, AddButton, Snackbar,
    CobranzaCreate,
    CobranzaUpdate,
    CobranzaDelete,
    CobranzaShow,
    CobranzaList
  },
  data() {
    return {
      title: 'cobrox.cobranza.title',
      subtitle: 'cobrox.cobranza.subtitle',
      flash: null,
      creating: false,
      updating: false,
      deleting: false,
      showing: false,
      itemToEdit: null,
      itemToDelete: null,
      itemToShow: null,
    }
  },
  methods: {
    //On
    onItemCreated() {
      this.$refs.list.fetch()
      this.flash = "common.created"
    },
    onItemUpdated() {
      this.$refs.list.fetch()
      this.flash = "common.updated"
    },
    onItemDeleted() {
      this.$refs.list.fetch()
      this.flash = "common.deleted"
    },
    //Open
    create() {
      this.creating = true
    },
    update(item) {
      this.updating = true
      this.itemToEdit = item
    },
    show(item) {
      this.showing = true
      this.itemToShow = item
    },
    remove(item) {
      this.deleting = true
      this.itemToDelete = item
    }
  }

}
</script>


